const queryString = require('query-string')

export const SERVER_URL_TOKEN = 'https://beta-identity.sekaans.com/connect/token'
// export const SERVER_URL_TOKEN = 'https://identity.sekaans.com/connect/token'

export const loginApi = (phone, code = '') => {
  let body = queryString['stringify']({
    username: phone,
    password: '',
    grant_type: 'password',
    client_id: 'sekaans-spa-client',
    client_secret: 'secret',
    scope: 'openid profile sekaans-api IdentityServerApi offline_access',
    verification_code: code
  })

  return { body, SERVER_URL: SERVER_URL_TOKEN }
}

